import React, { createContext, useContext, useEffect, useState } from "react";
import {fetchNotifications, markNotificationAsRead} from "./api";
import {AuthContext} from "./AuthProvider";

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);

    const {token} = useContext(AuthContext);

    useEffect(() => {
        if(!token) return;
        const fetchData = async () => {
            setLoading(true);
            const data = await fetchNotifications(token);
            setNotifications(data.notifications);
            setLoading(false);
        };

        fetchData();
    }, []);

    const markAsRead = async (notificationId) => {
        await markNotificationAsRead(token, notificationId);
        setNotifications((prev) =>
            prev.map((n) =>
                n.notification_id === notificationId ? { ...n, read: true } : n
            )
        );
    };

    return (
        <NotificationContext.Provider value={{ notifications, markAsRead, loading }}>
            {children}
        </NotificationContext.Provider>
    );
}

export function useNotifications() {
    return useContext(NotificationContext);
}
